import { ethers } from "ethers";
import { USDT_DECIMALS, SCN_DECIMALS } from "../config/app.config";

export function shortAddress(addr) {
  if (!addr) return "";
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

// Format an 18-dec BigNumber to a readable string with up to `maxFrac` decimals.
export function fmtUnits(bn, decimals = 18, maxFrac = 4) {
  if (bn === null || bn === undefined) return "0";
  try {
    const s = ethers.utils.formatUnits(bn, decimals);
    const [whole, frac = ""] = s.split(".");
    const trimmed = frac.slice(0, maxFrac).replace(/0+$/, "");
    return trimmed ? `${whole}.${trimmed}` : whole;
  } catch {
    return "0";
  }
}

export const fmtUsdt = (bn, maxFrac = 2) => fmtUnits(bn, USDT_DECIMALS, maxFrac);
export const fmtScn = (bn, maxFrac = 4) => fmtUnits(bn, SCN_DECIMALS, maxFrac);

// Parse a user-entered USDT string into a BigNumber.
export function parseUsdt(value) {
  return ethers.utils.parseUnits(String(value || "0"), USDT_DECIMALS);
}

// BigNumber -> JS number (for charts / count-up display only, not for math).
export function bnToNumber(bn, decimals = 18) {
  if (bn === null || bn === undefined) return 0;
  try {
    return parseFloat(ethers.utils.formatUnits(bn, decimals));
  } catch {
    return 0;
  }
}

export function formatTimestamp(ts) {
  if (!ts) return "-";
  const n = typeof ts === "object" && ts.toNumber ? ts.toNumber() : Number(ts);
  if (!n) return "-";
  return new Date(n * 1000).toLocaleString();
}
